import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AdminApp from "./AdminApp";
import LoginPage from "./components/LoginPage";
import { auth } from "./api/endpoints";
import { getToken, clearToken } from "./api/client";
import type { Admin } from "./api/types";
import { AdminDataProvider } from "./hooks/useAdminData";

function App() {
  const [admin, setAdmin] = useState<Admin | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (token) {
      auth.me()
        .then((a) => setAdmin(a))
        .catch(() => { /* token invalid, stay on login */ })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const handleLogout = () => {
    clearToken();
    setAdmin(null);
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0d0d0d' }}>
        <div style={{ color: '#D1004B', fontSize: '18px', fontWeight: 600 }}>Loading...</div>
      </div>
    );
  }

  if (!admin) {
    return <LoginPage onSuccess={setAdmin} />;
  }

  return (
    <AdminDataProvider>
      <AdminApp onLogout={handleLogout} admin={admin} />
    </AdminDataProvider>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

